// extracted by mini-css-extract-plugin
export default {"logo":"LoginError_logo__JrbkO","empty":"LoginError_empty__rHFWg","text":"LoginError_text__skgxq"};